export default __webpack_public_path__ + "static/media/ico-extracurriculares.f13bf4c9.svg";